import axios from "@/api/config";

const exam = {
  getExamById(data) {
    return axios.get(`${process.env.BASE_URL}/exam/getExam/` + data, {});
  },
  getExam(data) {
    return axios.get(`${process.env.BASE_URL}/exam/getExam`, { params: data });
  },
  getExamScoreInfo(data) {
    return axios.get(`${process.env.BASE_URL}/exam/getExamScoreInfo`, {
      params: data
    });
  },
  getExamList(data) {
    return axios.get(`${process.env.BASE_URL}/exam/getExamList`, {
      params: data
    });
  },
  getExamSelectListByCourse(data) {
    return axios.get(`${process.env.BASE_URL}/exam/getExamSelectListByCourse`, {
      params: data
    });
  },
  getExamTree(data) {
    return axios.get(`${process.env.BASE_URL}/exam/getExamTree`, {
      params: data
    });
  },
  updateExamVideo(data) {
    return axios.post(`${process.env.BASE_URL}/exam/updateExamVideo`, data);
  },

  examVideoList(data) {
    return axios.get(`${process.env.BASE_URL}/exam/examVideoList`, {
      params: data
    });
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/exam/pageList`, data);
  },
  addExam(data) {
    return axios.post(`${process.env.BASE_URL}/exam/addExam`, data);
  },
  updateExam(data) {
    return axios.put(`${process.env.BASE_URL}/exam/updateExam`, data);
  },
  copyExam(data) {
    return axios.post(`${process.env.BASE_URL}/exam/copyExamById`, data);
  },
  deleteExam(data) {
    return axios.delete(`${process.env.BASE_URL}/exam/deleteExam`, {
      data: data
    });
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/exam/exportExcel`, {
      params: data
    });
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/exam/importData`, data);
  }
};

export default exam;



// WEBPACK FOOTER //
// ./src/api/exam.js